export default {
  SET_INVOICES(state, invoices) {
    state.invoices = invoices
  },
  SET_UNPAID_INVOICES(state, invoices) {
    state.unpaidInvoices = invoices
  },
  SET_INVOICES_COUNT(state, count) {
    state.invoicesCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const invoiceIndex = state.invoices.findIndex(u => u.id === itemId)
    state.invoices.splice(invoiceIndex, 1)
  }
}
